/**
 * Pitto Design Tokens
 * Inspired by Vercel (minimal, near-black primary), Stripe (clear hierarchy), Linear (clean UI)
 */

// ============================================
// Colors
// ============================================
export const colors = {
  // Neutral
  primary: '#171717',
  bgPage: '#FAFAFA',
  bgCard: '#FFFFFF',
  bgSidebar: '#111111',
  bgSidebarHover: '#1a1a1a',
  bgSidebarActive: '#252525',
  border: '#EAEAEA',
  borderLight: '#F0F0F0',

  // Text
  textPrimary: '#171717',
  textSecondary: '#666666',
  textTertiary: '#999999',
  textInverse: '#FFFFFF',
  textSidebar: 'rgba(255,255,255,0.64)',
  textSidebarActive: '#FFFFFF',

  // Semantic
  success: '#17B169',
  successBg: '#F0FDF4',
  warning: '#F5A623',
  warningBg: '#FFFBEB',
  error: '#E5484D',
  errorBg: '#FEF2F2',
  info: '#3B82F6',
  infoBg: '#EFF6FF',
  accent: '#6366F1',
  accentBg: '#EEF2FF',
} as const;

// ============================================
// Spacing (4px base unit)
// ============================================
export const spacing = {
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  10: 40,
  12: 48,
  16: 64,
} as const;

// ============================================
// Border Radius
// ============================================
export const radius = {
  sm: 6,
  md: 8,
  lg: 12,
  xl: 16,
  full: 9999,
} as const;

// ============================================
// Shadows (minimal, Vercel-style)
// ============================================
export const shadows = {
  xs: '0 1px 2px rgba(0,0,0,0.04)',
  sm: '0 1px 3px rgba(0,0,0,0.06)',
  md: '0 4px 12px rgba(0,0,0,0.08)',
} as const;

// ============================================
// Typography
// ============================================
export const typography = {
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif",
  fontSize: {
    xs: 12,
    sm: 13,
    base: 14,
    md: 15,
    lg: 18,
    xl: 24,
    '2xl': 30,
  },
  fontWeight: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
} as const;

// ============================================
// Layout
// ============================================
export const layout = {
  sidebarWidth: 240,
  sidebarCollapsedWidth: 72,
  contentPaddingX: 40,
  contentPaddingY: 32,
} as const;
